// src/pages/career/OpenRoles.js
import { useEffect } from "react";
import "./openRoles.css";
import { Helmet } from "react-helmet";


export default function OpenRoles() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <Helmet>
        <title>SHOP.CO | Open Roles - Career Opportunities</title>
        <meta
          name="description"
          content="Discover open roles at SHOP.CO. Apply now and join our team to be part of building the future of online shopping."
        />

        <link
          rel="canonical"
          href="https://shop-co-roan.vercel.app/company/career/openRoles/"
        />
      </Helmet>
      <div className="open-roles-container">
        <h1 className="open-roles-title">We're Hiring!</h1>
        <p className="open-roles-description">Check out our available job roles and apply today.</p>

        <div className="career-job-cards">
          <div className="career-job-card">
            <h3>Customer Support Agent</h3>
            <p>Help customers with orders, returns, and general questions.</p>
            <a className="career-apply-btn" href="mailto:hr@yourdomain.com">Apply Now</a>
          </div>
          <div className="career-job-card">
            <h3>Position Product Photographer</h3>
            <p>Shoot and edit high-quality images of our latest styles.</p>
            <a className="career-apply-btn" href="mailto:hr@yourdomain.com">Apply Now</a>
          </div>
          <div className="career-job-card">
            <h3>Position Warehouse Assistant</h3>
            <p>Pack and ship orders with care and speed.</p>
            <a className="career-apply-btn" href="mailto:hr@yourdomain.com">Apply Now</a>
          </div>
          <div className="career-job-card">
            <h3>Position Marketing Coordinator</h3>
            <p>Promote our brand via social media & email campaigns.</p>
            <a className="career-apply-btn" href="mailto:hr@yourdomain.com">Apply Now</a>
          </div>
        </div>
      </div>

    </>
  );
}
